// smooth scrollbar
// console.log('is ie', isIE);

/**
 * Trigger a callback when the selected images are loaded:
 * @param {String} selector
 * @param {Function} callback
*/
 let onImgLoad = function(selector, callback){
    $(selector).each(function(){
        if (this.complete || /*for IE 10-*/ $(this).height() > 0) {
            callback.apply(this);
        }
        else {
            $(this).on('load', function(){
                callback.apply(this);
            });
        }
    });
};

if($('.banner-default').length > 0) {
    onImgLoad('.banner-default', function(){
        firstInit();
    });
} else {
    firstInit();
}

AOS.init({
    once: true,
    duration: 500
});

function firstInit() {
    if($(window).width() > 769) {
        scrollbar = Scrollbar.init(document.querySelector('#scroll-area'), ScrollbarOptions);
    }

    // $(document).ready(function () {
        var hash = location.hash;
    
        // console.log(hash);
    
        if(hash != '') {        
            setTimeout(function() {
                if($(window).width() > 768) {
                    scrollbar.scrollIntoView(document.querySelector(hash));
                } else {
        
                }
            }, 2000);
        }
    // });
}

if($(window).width() < 576) {
    $('.full-height').height($(window).innerHeight());
}


$(function () {
    // first load

    // header scroll
    var lastScrollTop = 0;
    
    if($(window).width() > 769) {
        scrollbar.addListener(function(s) {
            var st = s.offset.y;
    
            if (st > 0) {
                if (st <= lastScrollTop) {
                    $("header").addClass("fixed-top");
                    $("header").addClass("scrolling");
                    $('header').css('top', st + 'px');
                } else {
                    // $('header').css('top', '0px');
                }
            } else {
                $("header").removeClass("fixed-top");
                $("header").removeClass("scrolling");
                $('header').css('top', '0px');
            }
        
            if (st > $("header").height()) {
                
                if (st > lastScrollTop) {
                    $("header").addClass("scroll-down");
                    $("header").removeClass("scroll-up");
                } else {                    
                    $("header").removeClass("scroll-down");
                    $("header").addClass("scroll-up");
                }
            } else {
                // $('header').css('top', '0px');
                $("header").removeClass("scroll-up");
                $("header").removeClass("scroll-down");
            }
            // if (st > $("header").height() + 100) {
            //     $('header').css('top', st + 'px');
            // } else {

            // }
            lastScrollTop = st;
        });
    } else {
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();

            if (st > 0) {
                if (st <= lastScrollTop) {
                    $("header").addClass("fixed-top");
                    $("header").addClass("scrolling");
                }
            } else {
                $("header").removeClass("fixed-top");
                $("header").removeClass("scrolling");
            }
    
            if (st > $("header").height()) {
                if (st > lastScrollTop) {
                    $("header").addClass("scroll-down");
                    $("header").removeClass("scroll-up");
                } else {
                    $("header").removeClass("scroll-down");
                    $("header").addClass("scroll-up");
                }
            } else {
                $("header").removeClass("scroll-up");
                $("header").removeClass("scroll-down");
            }
            lastScrollTop = st;
        });        

        $('.navbar-toggler').click(function(event) {
            $('header').toggleClass('fixed');
        });
        
    }
    // end of header scroll
});

/*-*-*-*-*-*-* Parallax Start *-*-*-*-*-*-*-*-*-*/
(function($, window, undefined) {
    'use strict';
    /* ---------------- Globals -------------------- */
    var $window =                  $(window),
        windowHeight =             0,
        scrollTop =                0,
        scrollRatio = 0,
        $headerParallax = null;

      var objectsArr  = null;
      var $parallax   = null;
      var numParallax = null;

    /* --------------- Construction ---------------------- */
    function init() {

    if($(window).width() < 769) { return false; }

      windowHeight = $window.height();

      $parallax = $( '.js-parallax' );
      numParallax = $parallax.length;
      objectsArr = new Array( numParallax );

      $headerParallax = $('#header > .js-parallax');

      for(var i=0; i<numParallax; i++){
        objectsArr[i] = {
          el: $parallax[i],
          ratio: $parallax[i].getAttribute('data-ratio')
        }
      }

      $window.scroll(0);
      updatePage();

      $window.on('resize', onResize);
      $(document).on('scroll', onScroll );
      scrollbar.addListener(function(s) {
            onScroll();
      });

    }

    function onResize(){
      windowHeight = $window.height();
    }

    function onScroll(){
      scrollTop = scrollbar.scrollTop;
    }

    function getSupportedPropertyName(properties) {
        for (var i = 0; i < properties.length; i++) {
            if (typeof document.body.style[properties[i]] != "undefined") {
                return properties[i];
            }
        }
        return null;
    }
    
    /* ------------ Animation/Scrolling -------------- */
    
    function updatePage() {
      animateElements();
      requestAnimationFrame( updatePage );
    }

    function animateElements() {
      if ( $(window).width() > 900) {      
        var transform = ["transform", "msTransform", "webkitTransform", "mozTransform", "oTransform"];
        var transformProperty = getSupportedPropertyName(transform);

        for(var i=0; i<numParallax; i++){
          objectsArr[i].el.style[transformProperty] = "translateY("+( (scrollTop - scrollRatio ) * objectsArr[i].ratio )+"px) translateZ(0)";
        }
      } 
    }

    $(document).ready(init);
})($, window );
/*-*-*-*-*-*-*-*-*-*-* Parallax End *-*-*-*-*-*-*-*-*-*-*-*-*/

// custom select
var x, i, j, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < selElmnt.length; j++) {
        /* For each option in the original select element,
    create a new DIV that will act as an option item: */
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
            /* When an item is clicked, update the original select box,
        and the selected item: */
            var y, i, k, s, h;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName(
                        "same-as-selected"
                    );
                    for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
            window.location = $("#ChangeLang select").val();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
        /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}

function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
  except the current select box: */
    var x,
        y,
        i,
        arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i);
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);


// global animation

$(function () {
    let tl = [];

    if($(window).width() > 768) {
        $('.animated').each(function (index, element) {
            tl[index] = new TimelineMax();
            tl[index].from($(this), 1, { yPercent: $(this).data('offset'), rotation: 0.01}, "start");
        
            scenes.push(new ScrollMagic.Scene({ 
                    offset: 200, 
                    triggerHook: "onEnter", 
                    triggerElement: $(this).data('parent'), 
                    duration: sceneDuration*2, 
                    reverse:true 
                })
                .setTween(tl[index])
                .addTo(controller)
            );
        });
    }

    var startWGlobal = $(window).width(); // width before resize
    var resizeWGlobal = startWGlobal;
    var resizeTimerGlobal;

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimerGlobal);
        resizeTimerGlobal = setTimeout(function() {
            resizeWGlobal = $(window).width(); // width after resize
            if (startWGlobal < 769) {
                if (resizeWGlobal > 768) {
                    window.location.href = window.location;
                    // console.log('below '+startW, resizeW);
                }
            } else {
                if (resizeWGlobal <= 768) {
                    window.location.href = window.location;
                }
                // console.log('up '+startW, resizeW);
            }
    }, 250);
    });
});

$(function () {
    $('header .submenu').each(function () {
        // console.log($(this).children('a.active').length);
        if($(this).children('a.active').length > 0) {
            $(this).parent('.nav-item').addClass('active');
        }
    });

    $('p').each(function() {
        var $this = $(this);
        if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
            $this.remove();
    });
    
});

// slider area
$(function () {
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true,
            // maxWidth: 1100
        });
    });

    $('.card-slider').each(function() {
        var $cardArea = $(this).children('.card-area');
        var $cardNavigation = $(this).children('.card-navigation');

        // console.log($cardArea);
        $cardArea.carousel({
            pagination: false,
            touch: Modernizr && Modernizr.touch,
            translate3d: Modernizr && Modernizr.csstransforms3d,
            easing: 'linear',
            speed: 'fast',
            insertPrevAction: function () { 
                return $('<a href="#" class="rs-carousel-action rs-carousel-action-prev">Prev</a>').appendTo($cardNavigation); 
            },
            insertNextAction: function () { 
                return $('<a href="#" class="rs-carousel-action rs-carousel-action-next">Next</a>').appendTo($cardNavigation); 
            },
        });        
    });

    $('.slider-area--advanced').each(function() {
        var $mainSlider = $(this).children('.main-slider');
        var $Slidercaption = $(this).children('.slider-caption');
        $mainSlider .slick({
            infinite: false,
            dots: true,
            adaptiveHeight: true,
            asNavFor: $Slidercaption,
        });
    
        $Slidercaption.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            swipe: false,
            adaptiveHeight: true,
            asNavFor: $mainSlider 
        });
    });

    $('.slider-area--simple').each(function() {
        var $mainSlider = $(this).children('.main-slider');
        $mainSlider.slick({
            dots: false,
            infinite: false,
        });
    });

    $('*[draggable!=true]','.slick-track').unbind('dragstart');
});